module.exports = __webpack_public_path__ + "static/media/sound_sensitivity.8e982217.png";